interface IReturn {
  has_been_found: boolean;
  infoTitle?: string;
  infoText?: string;
}

// Accepts both the raw backend `IContentType[]` and the slice's prettified
// `IPrettifiedContentType[]` (see contentTypesSlice.ts) - only `type` (loosened
// to `string` since the prettified variant isn't a `contentTypeType` literal
// anymore), `title` and `description` are read here.
interface IContentTypeLike {
  type: string;
  title?: string;
  description?: string;
}

export const fromModelNameGetDescription = (
  contentTypeArray: IContentTypeLike[],
  modelName?: string,
): IReturn => {
  const fail = {
    has_been_found: false,
  };
  if (!modelName) return fail;
  const bingo = contentTypeArray.find((ct) => ct.type === modelName);
  return bingo
    ? {
        has_been_found: true,
        infoTitle: bingo?.title,
        infoText: bingo?.description,
      }
    : { ...fail };
};
